import { createRoot } from 'react-dom/client';
import './root.css';
import './App.css';
import { Preloader } from './components/Preloader';
import Routing from './routing';

if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

createRoot(document.getElementById('root')).render(
  <>
    <Preloader />
    <Routing />
  </>,
);
